// The portal header is outside .sp-main-scroll, so the content pane only
// needs a small breathing room at its own top edge.
export const FEEDBACK_PROGRESS_HEADER_OFFSET = 16;
export const FEEDBACK_PROGRESS_BOTTOM_PADDING = 24;

function resolveScrollContainer(progressNode, documentObject) {
  const portalScrollContainer = progressNode.closest?.(".sp-main-scroll");
  if (portalScrollContainer) return portalScrollContainer;

  let ancestor = progressNode.parentElement;
  while (ancestor) {
    const style = documentObject?.defaultView?.getComputedStyle?.(ancestor);
    if (style && /(auto|scroll)/.test(style.overflowY || "")) return ancestor;
    ancestor = ancestor.parentElement;
  }

  return documentObject?.scrollingElement || documentObject?.documentElement || null;
}

export function scrollFeedbackProgressIntoView(
  progressRef,
  { documentObject, windowObject } = {}
) {
  const progressNode = progressRef?.current;
  const resolvedWindow =
    windowObject || (typeof window === "undefined" ? null : window);
  const resolvedDocument =
    documentObject || (typeof document === "undefined" ? null : document);
  const container = progressNode && resolveScrollContainer(progressNode, resolvedDocument);
  if (
    !progressNode ||
    !container ||
    typeof progressNode.getBoundingClientRect !== "function" ||
    typeof container.getBoundingClientRect !== "function"
  ) return;

  const containerRect = container.getBoundingClientRect();
  const cardRect = progressNode.getBoundingClientRect();
  const availableHeight =
    container.clientHeight -
    FEEDBACK_PROGRESS_HEADER_OFFSET -
    FEEDBACK_PROGRESS_BOTTOM_PADDING;
  const targetOffset =
    cardRect.height <= availableHeight
      ? FEEDBACK_PROGRESS_HEADER_OFFSET + (availableHeight - cardRect.height) / 2
      : FEEDBACK_PROGRESS_HEADER_OFFSET;
  const cardTopInsideContainer =
    cardRect.top - containerRect.top + container.scrollTop;
  const targetScrollTop = cardTopInsideContainer - targetOffset;

  if (typeof container.scrollTo === "function") {
    container.scrollTo({
      top: Math.max(0, targetScrollTop),
      behavior: "smooth",
    });
    return;
  }

  // Fallback for the document scrolling element outside the portal shell.
  resolvedWindow?.scrollTo?.({
    top: Math.max(0, targetScrollTop),
    behavior: "smooth",
  });
}
